export interface ApiSecurityFeatureBoolean {
  enabled: boolean;
}

export enum InviteFlow {
  loading = "loading",
  password = "password",
  code = "code",
}

export enum InviteLoginMethod {
  google = "google",
  entra = "entra",
  oidc = "oidc",
}

export interface ApiInviteLoginMethods {
  login_methods: ("password" | InviteLoginMethod)[];
}

export interface InviteTokenPayload {
  type?: string;
}

export interface ApiSecurityFeatureWithValue {
  enabled: boolean;
  value: number;
}

export interface ApiSecurityLoginMethodEntra {
  enabled: boolean;
  tenant_ids: string[];
}

export interface ApiSecurityLoginMethodGoogle {
  enabled: boolean;
  hosted_domains: string[];
}

export interface ApiSecurityLoginMethodOidc {
  enabled: boolean;
  title: string;
  issuer: string;
  client_id: string;
  /** Только на запись; не передан — сохраняется прежний секрет */
  client_secret?: string;
  /** Только в ответе: секрет наружу не отдаётся */
  client_secret_set?: boolean;
  scopes: string[];
  email_claim: string;
  /** Только в ответе: адрес возврата, который вписывают в клиента у провайдера */
  redirect_uri?: string;
}

export interface ApiSecurityLoginMethods {
  password: ApiSecurityFeatureBoolean;
  google: ApiSecurityLoginMethodGoogle;
  entra: ApiSecurityLoginMethodEntra;
  oidc: ApiSecurityLoginMethodOidc;
}

export interface ApiLoginMethodOidc {
  organization_id: number;
  title: string;
}

export interface ApiEmployeeLoginMethods {
  password: boolean;
  oidc: ApiLoginMethodOidc[];
}

export interface ApiLoginOrganization {
  id: number;
  title: string;
}

export interface ApiSecurityIpAllowlist {
  enabled: boolean;
  networks: string[];
}

export interface ApiSecuritySettings {
  login_methods: ApiSecurityLoginMethods;
  require_tfa: ApiSecurityFeatureBoolean;
  allowed_domains: string[];
  ip_allowlist: ApiSecurityIpAllowlist;
  /** Только в ответе: адрес, с которого открыта страница */
  current_ip?: string;
  password_expiry_days: ApiSecurityFeatureWithValue;
  password_min_length: ApiSecurityFeatureWithValue;
  require_strong_password: ApiSecurityFeatureBoolean;
}
